import { render, staticRenderFns } from "./reserve-page.vue?vue&type=template&id=4f0b301e&scoped=true&lang=pug"
import script from "./reserve-page.vue?vue&type=script&lang=js"
export * from "./reserve-page.vue?vue&type=script&lang=js"
import style0 from "./reserve-page.vue?vue&type=style&index=0&id=4f0b301e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0b301e",
  null
  
)

export default component.exports